import React from "react";

interface LogoProps {
  className?: string;
  variant?: "serif" | "display" | "sans";
  size?: "sm" | "md" | "lg" | "xl";
}

export const Logo: React.FC<LogoProps> = ({
  className = "",
  variant = "serif",
  size = "md",
}) => {
  const text = "Weave";
  const letters = text.split("");

  const fontClass = {
    serif: "font-serif",
    display: "font-display",
    sans: "font-sans",
  }[variant];

  const sizeClass = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-6xl",
  }[size];

  const opacities = [0.15, 0.35, 0.6, 0.82, 1];

  return (
    <h1
      className={`${fontClass} ${sizeClass} font-bold text-primary ${className}`}
      style={{
        letterSpacing: "0.02em",
      }}
    >
      {letters.map((letter, index) => {
        const uniqueKey = `logo-char-${index}`;
        return (
          <span
            key={uniqueKey}
            style={{
              opacity: opacities[index],
              transition: "opacity 0.3s ease-in-out",
            }}
            className="inline-block"
          >
            {letter}
          </span>
        );
      })}
    </h1>
  );
};
